var _metadata, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    xmlnsvectornator: "http://vectornator.io",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "Units",
    value: "Pixels"
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToGrid",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "OutlineMode",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToEdges",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "PencilOnly",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "GuidesVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DynamicGuides",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "IsolateActiveLayer",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DisplayWhiteBackground",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "RulersVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "DimensionsVisible",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "doHistoryDisabled",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToPoints",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "SnapToGuides",
    value: 1
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "TimeLapseWatermarkDisabled",
    value: 0
  }), /*#__PURE__*/React.createElement("vectornatorSetting", {
    key: "CMYKEnabledKey",
    value: 0
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y1: 383.558,
    id: "LinearGradient",
    x1: 379.646,
    y2: 381.585,
    x2: 622.732,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.86277 3.1828 -3.1828 2.86277 318.937 -2160.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0c2a2",
    offset: 0.282382
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62e1da",
    offset: 0.529079
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e16262",
    offset: 0.807473
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    vectornatorlayername: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 11,
    d: "M184.989+145.63C402.664-50.1571+737.841-32.4141+933.628+185.26C1129.42+402.935+1111.67+738.112+893.998+933.899C676.324+1129.69+341.147+1111.94+145.359+894.27C-50.428+676.595-32.6852+341.418+184.989+145.63Z",
    fill: "url(#LinearGradient)",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89d4165491a11148b5159f6426138d9e.svg";
export { ForwardRef as ReactComponent };